import { PipeTransform } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var GetValueService = /** @class */ (function () {
    function GetValueService(fuseTranslationLoaderService, translateService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.translateService = translateService;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    GetValueService.prototype.transform = function (orderProductService, companyId) {
        var productServiceCompany = orderProductService.item.productServiceCompanies.find(function (psc) { return psc.company.id === companyId; });
        var isCustom = !!(productServiceCompany.preferences && productServiceCompany.preferences.weekDayValues);
        if (isCustom) {
            return {
                tooltip: this.translateService.instant('CUSTOM_VALUE.TOOLTIP'),
                label: this.translateService.instant('CUSTOM_VALUE.LABEL')
            };
        }
        return {
            tooltip: null,
            label: "R$" + new Intl.NumberFormat('pt-BR', {
                minimumFractionDigits: 2
            }).format(orderProductService.value || 0)
        };
    };
    return GetValueService;
}());
export { GetValueService };
